import * as angular from "angular";
import {IController} from "angular";


export class FulfillmentLineStatusComponent implements IController {

  displayStatus: string;

  constructor() {
  }

  $onInit() {
  }


}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineStatus', {
    bindings: {
      displayStatus: '<',
    },
    template: require('./fulfillment-line-status.html').default,
    controller: FulfillmentLineStatusComponent
  });
